import { isIndividualStateRoute, StateConfig } from "@/lib/states-config";

export function doesBoardMatchPreferenceState(
  stateConfig: StateConfig,
  preferenceStateAbbreviation: string | undefined | null,
): boolean {
  if (!isIndividualStateRoute(stateConfig.route)) return true;
  return stateConfig.abbreviation === preferenceStateAbbreviation;
}
